import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import { forwardRef } from 'react';
import { themed, getDefaultThemedOptions } from '@indeed/ifl-css';
import { FORM_SIZES } from '../../constants/index.js';
import transition from '../../utils/transition.js';
import createResponsive from '../../utils/createResponsive.js';
import { jsx } from '@emotion/react';
import { Label } from '../Label/Label.js';
import { Box } from '../Box/Box.js';
import '../../utils/styled.js';
import '../VisuallyHidden/VisuallyHidden.js';

const labelSizes = {
  sm: "3",
  md: "sc3"
};
const sizes = {
  sm: 1.25,
  md: 1.5
};
const getSize = createResponsive(size => `${sizes[size]}rem`);
const getLabelPaddingBlock = createResponsive(size => labelSizes[size]);
const getDotSize = createResponsive(size => `${sizes[size] / 2}rem`);
const RadioInput = /*#__PURE__*/themed("input", process.env.NODE_ENV === "production" ? _extends({}, {
  target: "e1rw0n9c0"
}, getDefaultThemedOptions("inputSize", "invalid")) : _extends({}, {
  target: "e1rw0n9c0",
  label: "RadioInput"
}, getDefaultThemedOptions("inputSize", "invalid")))(_ref => {
  let {
    inputSize = "md",
    invalid
  } = _ref;
  return {
    appearance: "none",
    position: "relative",
    boxSizing: "border-box",
    inlineSize: getSize(inputSize),
    blockSize: getSize(inputSize),
    borderRadius: "full",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: invalid ? "border.status.critical.strong" : "border.action",
    bg: "background.action",
    cursor: "pointer",
    marginBlockStart: 0,
    marginBlockEnd: 0,
    marginInlineStart: 0,
    marginInlineEnd: 0,
    flexShrink: 0,
    transition: _ref2 => {
      let {
        transitions
      } = _ref2;
      return transition(transitions.default, "background-color", "border-color", "box-shadow");
    },
    "@media (prefers-reduced-motion: reduce)": {
      transition: "none"
    },
    "&:hover": {
      bg: "background.action.hover",
      borderColor: "border.action.hover"
    },
    "&:active": {
      bg: "background.action.active",
      borderColor: "border.action.active"
    },
    "&:focus-visible": {
      outline: 0,
      boxShadow: "focus"
    },
    "&:after": {
      content: "''",
      position: "absolute",
      top: "50%",
      left: "50%",
      inlineSize: getDotSize(inputSize),
      blockSize: getDotSize(inputSize),
      borderRadius: "full",
      bg: "transparent",
      transform: "translate(-50%, -50%)",
      transition: _ref3 => {
        let {
          transitions
        } = _ref3;
        return `background-color ${transitions.default}`;
      },
      "@media (prefers-reduced-motion: reduce)": {
        transition: "none"
      }
    },
    // Selected
    "&:checked:after": {
      bg: "background.inverse"
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

/**
 * @see https://experience.indeed.design/components/ids/radio
 */
const Radio = /*#__PURE__*/forwardRef((_ref4, ref) => {
  let {
    as = "label",
    className,
    children,
    disabled,
    id,
    invalid,
    label,
    size = "md",
    sx,
    ...props
  } = _ref4;
  return jsx(Label, {
    as: as,
    htmlFor: id,
    disabled: disabled,
    size: size,
    className: className,
    sx: {
      display: "flex",
      fontWeight: "normal",
      position: "relative",
      paddingBlockStart: getLabelPaddingBlock(size),
      paddingBlockEnd: getLabelPaddingBlock(size),
      cursor: "pointer",
      ...sx
    }
  }, jsx(RadioInput, _extends({
    id: id,
    ref: ref,
    type: "radio",
    inputSize: size,
    disabled: disabled,
    invalid: invalid,
    "aria-invalid": invalid
  }, props)), children || label ? jsx(Box, {
    as: "span",
    sx: {
      flexGrow: 1,
      marginInlineStart: 3
    }
  }, children || label) : null);
});
const RADIO_SIZES = FORM_SIZES;
Radio.displayName = "Radio";

export { RADIO_SIZES, Radio };
